import React from 'react';
import './banner-image.component.css';

const BannerImage = () => {
  return (
    <div className="banner-image">
        <img src="images/developer.png" alt="developer-icon" width='250px'/>
    </div>
  )
}

export default BannerImage